import {
  URL_DOMAIN,
  getJSON,
  URL_P2,
  requestOptionsGet,
  requestOptionsPost,
  requestOptionsPut,
  URL_DOMAIN_MARKET
} from "../globals";

const URL_FINAL = URL_DOMAIN + URL_P2[2];



const getPaginatedServiceCategories = async (page, rowsPerPage, searchQuery = null) => {
  const fk_organization = localStorage.getItem("fk_organization")
  let url = `${URL_DOMAIN}product-category/get-paginated-all-service-category?fk_organization=${fk_organization}&results_per_page=${rowsPerPage}&page_number=${page + 1}`
  if (searchQuery !== null) {
    url += `&query_string=${searchQuery}`
  }
  try {
    const response = await fetch(
      url,
      requestOptionsGet
    )
    if (!response.ok) {
      throw new Error("Error al obtener los datos de ventas");
    }

    return getJSON(response);
  } catch (error) {
    throw new Error("Error al obtener los datos de ventas: ");
  }
};


const postServiceCategory = async (formData) => {
  requestOptionsPost.body = formData;
  return fetch(URL_DOMAIN + "product-category/create-service-category", requestOptionsPost).then(
    getJSON
  );
};

const putServiceCategory = async (formData) => {
  requestOptionsPut.body = formData;
  return fetch(URL_DOMAIN + "product-category/edit-service-category", requestOptionsPut).then(
    getJSON
  );
};

const getServicesCategoriesofOrganization = async (fkOrganization) => {
  return fetch(URL_DOMAIN_MARKET + "/product-category/get-all-service-category?fk_organization=" + fkOrganization, requestOptionsGet).then(
    getJSON
  );
}
export { getPaginatedServiceCategories, getServicesCategoriesofOrganization, putServiceCategory, postServiceCategory }